import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './DailyForecast.scss';

export const DailyForecast = ({ className, data }) => {
  const classes = classNames('daily-forecast', className);

  if (data.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      {data.map(
        (
          { temperature, isDaytime, name, shortForecast, time, icon },
          index,
        ) => {
          const tempClasses = classNames('temp', isDaytime && 'red');
          return (
            <div key={`forecast-box-${index}`} className='forecast-box'>
              <p className='time'>{name}</p>
              <img className='weather-image' src={icon} alt={shortForecast} />
              <p className={tempClasses}>
                {isDaytime ? 'High' : 'Low'}: {temperature}
              </p>
              <p className='status'>{shortForecast}</p>
            </div>
          );
        },
      )}
    </div>
  );
};

DailyForecast.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
};

DailyForecast.defaultProps = {
  data: [],
};

export default DailyForecast;
